import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import { useMemo } from 'react';
import { Element } from 'react-scroll';
import { propFunc, propNumber, propShape, } from '../../../../../../../helpers/custom-prop-types';
import { parseNumberToCircleString } from '../../../../../../../helpers/string';
import InputError from '../../../../../../Ui/Common/InputError';
import PlainInput from '../../../../../../Ui/Common/PlainInput';
const AccountPlanTrialFormEmailField = (props) => {
    const { index, input, length, meta, onClickDelete } = props;
    const title = useMemo(() => `ご紹介先メールアドレス${parseNumberToCircleString(index + 1)}`, [index]);
    return (_jsxs(Element, Object.assign({ className: 'proffit_search_account_plan_trial_form_email', name: `${input.name}_view` }, { children: [_jsx("div", Object.assign({ className: 'email_input' }, { children: _jsxs("div", Object.assign({ className: 'field' }, { children: [_jsx("div", Object.assign({ className: 'field_title' }, { children: title })), _jsxs("div", Object.assign({ className: 'field_input' }, { children: [_jsx(PlainInput, { className: '', input: input, meta: meta, placeholder: 'メールアドレス', type: 'email' }), _jsx(InputError, { className: 'input_error', meta: meta })] }))] })) })), _jsx("div", Object.assign({ className: 'email_delete' }, { children: _jsx("button", Object.assign({ className: clsx('delete_icon', length === 1 && 'is-dnone'), disabled: false, onClick: onClickDelete, type: 'button', value: index }, { children: _jsx(CloseIcon, {}) })) }))] })));
};
AccountPlanTrialFormEmailField.propTypes = {
    index: propNumber().isRequired,
    input: propShape().isRequired,
    length: propNumber().isRequired,
    meta: propShape().isRequired,
    onClickDelete: propFunc().isRequired,
};
export default AccountPlanTrialFormEmailField;
